import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '@/lib/analytics';

/**
 * AnalyticsTracker Component
 * Automatically initializes Google Analytics and tracks page view events on route changes.
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics once on mount
    initGA();
  }, []);

  useEffect(() => {
    // Track page views when pathname or search parameters change
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
